const mockTilesData = [
  {
    theme: 'Vehicles',
    words: ['Car', 'Bus', 'Bike', 'Truck'],
    category: 1,
  },
  {
    theme: 'Animals',
    words: ['Lion', 'Tiger', 'Elephant', 'Giraffe'],
    category: 2,
  },
  {
    theme: 'Fruits',
    words: ['Apple', 'Banana', 'Cherry', 'Date'],
    category: 3,
  },
  {
    theme: 'Planets',
    words: ['Pluto', 'Mars', 'Earth', 'Venus'],
    category: 4,
  },
];

export default mockTilesData;
